<script setup lang="ts">
import { AttachmentContentType } from 'common/enum/entry.attachment.enum';
import { EPendingAttachmentStatus, type IPendingAttachment } from '@/composables/attachments/useAttachmentUploads';
import AttachmentCard from './AttachmentCard.vue';
withDefaults(defineProps<{ items: IPendingAttachment[]; inline?: boolean }>(), { inline: false });
const emit = defineEmits<{ remove: [id: number] }>();
</script>

<template>
  <div
    v-if="items.length"
    :class="inline ? 'contents' : 'flex w-full flex-wrap gap-md md:grid md:grid-cols-3'"
    aria-live="polite"
  >
    <AttachmentCard
      v-for="item in items"
      :key="`${item.id}-${item.imageUrl}`"
      :removable="item.status === EPendingAttachmentStatus.Pending"
      :item="{
        id: item.id,
        name: item.file.name,
        type: item.imageUrl ? AttachmentContentType.Image : AttachmentContentType.File,
        imageSource: item.imageUrl,
        url: null,
      }"
      @remove="emit('remove', item.id)"
    />
  </div>
</template>
